import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-adhesion',
  templateUrl: './fh-svg-adhesion.component.html',
  styleUrl: './fh-svg-adhesion.component.scss'
})
export class FhSvgAdhesionComponent {
  @Input() color: string = '';
}
